import { Monitor, Tv2, ChevronDown } from "lucide-react";
import { useState } from "react";

export type OutputTarget = "browser" | "wallace-tv";

const STORAGE_KEY = "wallace-tv-output-target";

export function getSavedTarget(): OutputTarget {
  return (localStorage.getItem(STORAGE_KEY) as OutputTarget | null) ?? "wallace-tv";
}

function saveTarget(t: OutputTarget): void {
  localStorage.setItem(STORAGE_KEY, t);
}

interface OutputPickerProps {
  value: OutputTarget;
  onChange: (target: OutputTarget) => void;
}

export function OutputPicker({ value, onChange }: OutputPickerProps): JSX.Element {
  const [open, setOpen] = useState(false);

  function select(t: OutputTarget): void {
    saveTarget(t);
    onChange(t);
    setOpen(false);
  }

  const label = value === "wallace-tv" ? "Send to TV" : "Play on Browser";
  const Icon = value === "wallace-tv" ? Tv2 : Monitor;

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="pill-ghost gap-1.5 text-xs"
        title="Choose where to play"
      >
        <Icon size={13} className={value === "wallace-tv" ? "text-jade" : ""} />
        <span>{label}</span>
        <ChevronDown size={11} className={open ? "rotate-180 transition-transform" : "transition-transform"} />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 z-50 min-w-[180px] bg-ink border border-hairline rounded-lg shadow-xl py-1">
          <button
            onClick={() => select("browser")}
            className={`w-full text-left px-3 py-2 text-xs flex items-center gap-2 hover:bg-parchment/10 ${value === "browser" ? "text-gold" : "text-ivory"}`}
          >
            <Monitor size={13} />
            Play on This Browser
          </button>
          <div className="border-t border-hairline my-1" />
          <button
            onClick={() => select("wallace-tv")}
            className={`w-full text-left px-3 py-2 text-xs flex items-center gap-2 hover:bg-parchment/10 ${value === "wallace-tv" ? "text-jade" : "text-ivory"}`}
          >
            <Tv2 size={13} />
            Send to TV
          </button>
        </div>
      )}
    </div>
  );
}
